export default "__VITE_ASSET__BwXeBHzU__"